module.exports = __webpack_public_path__ + "static/gallery_wild_2_thumb-3c0c55cb0b25c6d1521ac9466527b781.jpg";